import React from "react";
import Card from "react-bootstrap/Card";

const FAQ = () => {
  return (
    <div className="container mt-5 mb-5">
      <h1 className="text-center text-primary fw-bold">Read Our FAQ</h1>
      <Card className="mt-5 shadow-lg">
        <Card.Header className="p-3 ps-5"><h3>About us</h3></Card.Header>
        <Card.Body>
          {/* <Card.Title>Special title treatment</Card.Title> */}
          <Card.Text className="p-4">
            Schooling IT Institute is a trusted organization dedicated to
            creating breakthroughs in IT. Since its inception, Schooling IT has
            achieved multifaceted success in the long 13 years. Contributing to
            the construction of digital Bangladesh. One of the leading IT
            companies in Bangladesh has been playing an important role in
            eliminating the unemployment problem since 2008.
          </Card.Text>
        </Card.Body>
      </Card>
      <Card className="mt-4 shadow-lg">
        <Card.Header className="p-3 ps-5"><h3>Our Milestone</h3></Card.Header>
        <Card.Body>
          {/* <Card.Title>Special title treatment</Card.Title> */}
          <Card.Text className="p-4">
            Schooling IT Institute has successfully provided IT training to more
            than 42 thousand people besides providing quality information
            technology training to people of all classes and professions of the
            country for 13 years. In recognition of this, some of the highlights
            of the achievements of Mohammad Rakib, the respected founder and CEO
            of the organization.
          </Card.Text>
        </Card.Body>
      </Card>
      <Card className="mt-4 shadow-lg">
        <Card.Header className="p-3 ps-5">
          <h3>Making IT Expert Trusted organization in the world</h3>
        </Card.Header>
        <Card.Body>
          {/* <Card.Title>Special title treatment</Card.Title> */}
          <Card.Text className="p-4">
            Schooling IT Institute is at your side to keep yourself updated with
            modern technology. Be it IT sector or non-IT sector, IT experts are
            now in good demand everywhere. That is why we have been creating IT
            experts for 13 years with updated curriculum, experienced mentors
            and modern labs. As a result of this, we have found more than 50
            thousand successful faces, who have become self-reliant and created
            employment for more people. And the success of these students is the
            inspiration for our journey.
          </Card.Text>
        </Card.Body>
      </Card>
      <Card className="mt-4 mb-5 shadow-lg">
        <Card.Header className="p-3 ps-5">
          <h3>One of the ISO certified IT training institutes in the country</h3>
        </Card.Header>
        <Card.Body>
          {/* <Card.Title>Special title treatment</Card.Title> */}
          <Card.Text className="p-4">
            Creative IT won a great honor in 2015. Recognized as one of the ISO
            certified training institutes in Bangladesh. The main function of
            ISO is to define standards on various subjects of industry and
            commerce, formulate and issue quality certificates to various
            organizations. So this certificate given by ISO is a great honor for
            Creative IT. This proves that we are ensuring quality services,
            international course modules and improved environment as per the
            demand of time.
          </Card.Text>
        </Card.Body>
      </Card>
      <Card className="mt-4 mb-5 shadow-lg">
        <Card.Header className="p-3 ps-5"><h3>Our Purpose</h3></Card.Header>
        {/* <Card.Title>Special title treatment</Card.Title> */}
        <Card.Body>
          
          <Card.Text className="p-3 ps-5">
            Empowering the people of the country by harnessing the power of
            youth and ensuring modern and quality training methods.
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
};

export default FAQ;
